import AdminDashboard from "./pages/AdminDashboard";
import { scheduleVisit } from "./Services/visitService";
import uiI18n from "./i18n";
import { useTranslation as useUiTranslation } from "react-i18next";
import { EngagementProvider } from "./context/EngagementContext";
import Engagement, { EngagementLinks } from "./pages/Engagement";
import React, { useEffect, useLayoutEffect } from 'react';
import {BrowserRouter  as Router, Routes, Route, Navigate, useLocation} from "react-router-dom";
import CreateBien  from './pages/CreateBien';
import CreateVacation  from './pages/CreateVacation';
import CreatePartyRooms  from './pages/CreatePartyRooms';
import Profile from "./pages/Profile";
import MyAds from "./pages/MyAds";
 import SignUp from "./pages/SignUp";
import Header from './components/Header';
import ForgotPassword from './pages/ForgotPassword';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css"
import OAuth from "./components/OAuth";
import Home from "./pages/Home"
import SignIn  from './pages/SignIn';
import  PrivateRoute from "./components/PrivateRoute";
import EditListing from "./pages/EditListing";
import EditVacation from "./pages/EditVacation";
import Listing from "./pages/Listing"
import Offers from "./pages/Offers"
import Category from './pages/Category';

import './i18n';
import Footer from './components/Footer';
import LinaAiChat from './components/LinaAiChat';
import Vacation from './pages/Vacation';
import PartyRooms from './pages/PartyRooms';
//import Favorites from './pages/Favorites';
import DetailsVacation from './pages/DetailsVacation';

import Reservation from './pages/Reservation';
import AllReservation from './pages/AllReservation';
import AllRequest from './pages/AllRequest';
import ConversationPage from './pages/ConversationPage';
import BiensByCity from './pages/BiensByCity';
import CategoryByVille from "./pages/CategoryByVille";
import NotificationComponent from "./components/NotificationComponent";
import { MessageProvider } from "./context/MessageContext";

import { About, Contact, Terms, Privacy } from "./pages/PublicPages";
import PropertyRequestNew from "./pages/PropertyRequestNew";
import PropertyRequestEdit from "./pages/PropertyRequestEdit";
import PropertyRequests from "./pages/PropertyRequests";
import PropertyRequestDetail from "./pages/PropertyRequestDetail";
import PropertyRequestPropose from "./pages/PropertyRequestPropose";
import MyPropertyRequests from "./pages/MyPropertyRequests";

function ScrollToTop() {
  const location = useLocation();

  useLayoutEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => { window.history.scrollRestoration = previous; };
  }, []);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location]);

  return null;
}

function App() {
  useUiTranslation();
  // Admin visitor counter: once per browser and per day, in the background.
  useEffect(() => { scheduleVisit(); }, []);
  return (
    <>
    <Router>
    <ScrollToTop />
    <EngagementProvider><MessageProvider>
       <Header/><EngagementLinks/>
       <NotificationComponent />
       <Routes>
         <Route path="/admin/*" element={<AdminDashboard />} />
         <Route path="/about" element={<About />} />
         <Route path="/contact" element={<Contact />} />
         <Route path="/terms" element={<Terms />} />
         <Route path="/privacy" element={<Privacy />} />
<Route path="/favorites" element={<Engagement/>}/><Route path="/recently-viewed" element={<Engagement mode="recently-viewed"/>}/><Route path="/recent-searches" element={<Engagement mode="recent-searches"/>}/>
       <Route path="/BiensByCity/:city" element={<BiensByCity />} />
       <Route path="/DetailsVacation/:bienID" element={<DetailsVacation/>} />
       <Route path="/DetailsPartyRooms/:bienID" element={<DetailsVacation/>} />
       <Route path="/DetailsPartyRooms" element={<Navigate to="/PartyRooms" replace/>} />
        <Route path="/" element={< Home/>} />
        <Route path="/oauth" element={<OAuth/>} />
        <Route path="/ForgotPassword" element={<ForgotPassword/>} />
        <Route path="/Offers" element={<Offers/>} />
        <Route path="/Hote" element={<Navigate to="/createbien" replace/>} />
        <Route path='/category/:categoryName/:listingID'
         element={<Listing/>}>
         </Route>
         <Route path="/category/:categoryName" element={<Category/>} />

        <Route path="/listing/:bienID" element={<Listing />} />
          <Route path='/profile' element={<PrivateRoute/>}>
            <Route path='/profile' element={<Profile/>} />
         </Route>
         <Route path='/myAds' element={<PrivateRoute/>}>
            <Route path='/myAds' element={<MyAds/>} />
         </Route>
           <Route path='/Reservation/:reservationID' element={<PrivateRoute/>}>
            <Route path='/Reservation/:reservationID' element={<Reservation/>} />
         </Route>
          <Route path='/AllReservation' element={<PrivateRoute/>}>
            <Route path='/AllReservation' element={<AllReservation/>} />
         </Route>
         <Route path='/ConversationPage' element={<PrivateRoute/>}>
            <Route path='/ConversationPage' element={<ConversationPage/>} />
         </Route>
         <Route path='/AllRequest' element={<PrivateRoute/>}>
            <Route path='/AllRequest' element={<AllRequest/>} />
         </Route>
         <Route path='createbien' element={<PrivateRoute/>}>
            <Route path='/createbien' element={<CreateBien/>} />
         </Route>
          <Route path='createVacation' element={<PrivateRoute/>}>
            <Route path='/createVacation' element={<CreateVacation/>} />
         </Route>
          <Route path='createPartyRooms' element={<PrivateRoute/>}>
            <Route path='/createPartyRooms' element={<CreatePartyRooms/>} />
         </Route>
         <Route path="editlisting" element={<PrivateRoute />}>
         <Route path=":bienID" element={<EditListing />} />
         </Route>
         <Route path='editVacation' element={<PrivateRoute/>}>
            <Route path='/editVacation/:bienID' element={<EditVacation/>} />
         </Route>
         <Route path="/property-request/new" element={<PropertyRequestNew/>} />
         <Route path="/property-requests" element={<PropertyRequests/>} />
         <Route path="/property-request/:id" element={<PropertyRequestDetail/>} />
         <Route path="/property-request/:id/edit" element={<PrivateRoute/>}>
            <Route path="/property-request/:id/edit" element={<PropertyRequestEdit/>} />
         </Route>
         <Route path="/property-request/:id/propose" element={<PrivateRoute/>}>
            <Route path="/property-request/:id/propose" element={<PropertyRequestPropose/>} />
         </Route>
         <Route path="/my-property-requests" element={<PrivateRoute/>}>
            <Route path="/my-property-requests" element={<MyPropertyRequests/>} />
         </Route>
         <Route path="/SignIn" element={<SignIn/>} />
         <Route path="/signup" element={<SignUp/>} />
         <Route path="/Vacation" element={<Vacation/>} />
         <Route path="/PartyRooms" element={<PartyRooms/>} />

          <Route path="/categorybyville" element={<CategoryByVille />} />
         <Route path="*" element={<main className="p-8">{uiI18n.t("ui.page_not_found")} <a href="/">{uiI18n.t("ui.home")}</a></main>} />
         </Routes>
       {  <Footer />  }
       <LinaAiChat />
     </MessageProvider></EngagementProvider>
    </Router>
    <ToastContainer
      position="bottom-center"
      autoClose= {5000}
      hideProgressBar ={false}
      newestOnTop = {false}
      closeOnClick
      rtl={uiI18n.dir() === 'rtl'}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
    />

  </>

  );
}

export default App;
